import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEc2Status, signin, updateEc2Status } from "../features/ec2DetailSlicer";
import "@fortawesome/fontawesome-free/css/all.min.css";

export default function SignIn() {
  // const [data, SetData]=useState([]);
  const loading = useSelector((state) => state.ec2App.loading);
  const status = useSelector((state) => state.ec2App.status);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [tag, setTag] = useState("");
  const [triggerFetch, setTriggerFetch] = useState(false);
  const [isOn, setIsOn] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(signin({ email, password }));
  };

  return (
    <div className="login-box">
      <div className="form">
        <form className="login-form" onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="email"
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder="password"
            onChange={(e) => setPassword(e.target.value)}
          />
          <button>login</button>
          <p className="message">
            <a href="mailto:ammar.raza@oztechwork.com">
              ammar.raza@oztechwork.com
            </a>
          </p>
        </form>
      </div>
    </div>
  );
}
